import * as Turbo from "@hotwired/turbo";
import Rails from "@rails/ujs";
import "@stripe/stripe-js";

// Init Stimulus Controllers
import "@/controllers/give";

// Init Rails UJS
Rails.start();

// Init Turbo for navigation
Turbo.start();

// Handle Turbo Page Load
window.addEventListener("turbo:load", (_event) => {
  // Remove flash messages after page load
  const flashMessageElement = document.querySelector(".flash");
  if (flashMessageElement) {
    flashMessageElement.remove();
  }
});
